// language=HTML
const template = `
    <article class="company">
        <md-content>
            <h1 class="md-display-2 section-title">Company</h1>

            <installation-breadcrumbs></installation-breadcrumbs>

            <app-loading ng-if="loading"></app-loading>

            <form autocomplete="off" name="form"
                  ng-if="!loading"
                  ng-submit="updateCompany($event)">

                <md-card class="app-form-card">
                    <md-card-content>
                        <app-input-text
                            form="form"
                            label="Company Name"
                            value="company.name"
                            required>
                        </app-input-text>

                        <h2 class="form-section-header">Contact Details</h2>

                        <div class="form-row">
                            <app-input-email
                                class="flex"
                                form="form"
                                label="Email Address"
                                value="company.email"
                                required>
                            </app-input-email>

                            <app-input-text
                                class="flex"
                                form="form"
                                label="Phone Number"
                                value="company.phone"
                                required>
                            </app-input-text>
                        </div>

                        <h2 class="form-section-header">Address</h2>

                        <div class="form-row">
                            <app-input-text form="form"
                                            class="flex-50"
                                            name="street_1"
                                            label="Street 1"
                                            value="company.address.street_1"
                                            required="true">
                            </app-input-text>

                            <app-input-text form="form"
                                            class="flex-50"
                                            name="county"
                                            label="County"
                                            value="company.address.county">
                            </app-input-text>
                        </div>

                        <div class="form-row">
                            <app-input-text form="form"
                                            class="flex-50"
                                            name="street_2"
                                            label="Street 2"
                                            value="company.address.street_2">
                            </app-input-text>

                            <app-input-text form="form"
                                            class="flex-50"
                                            name="post_code"
                                            label="Post Code"
                                            value="company.address.post_code"
                                            required="true">
                            </app-input-text>
                        </div>

                        <div class="form-row">
                            <app-input-text form="form"
                                            class="flex-50"
                                            name="town"
                                            label="Town"
                                            value="company.address.town">
                            </app-input-text>

                            <app-input-select form="form"
                                              class="flex-50"
                                              name="country"
                                              label="Country"
                                              options="countrySelectOptions"
                                              value="company.address.country">
                            </app-input-select>
                        </div>
                    </md-card-content>

                    <md-card-actions>
                        <md-button class="md-raised md-primary"
                                   type="submit"
                                   ng-disabled="form.$invalid || updating">
                            Save
                        </md-button>
                    </md-card-actions>
                </md-card>
            </form>
        </md-content>
    </article>
`;

CompanyController.$inject = ['$app', '$errorHandler', '$installation', '$scope', '$settingsFetcher', '$state', '$util'];

function CompanyController($app, $errorHandler, $installation, $scope, $settingsFetcher, $state, $util) {
    // Properties
    $scope.company = {};
    $scope.countrySelectOptions = [
        { value: 'United Kingdom', label: 'United Kingdom' },
        { value: 'Australia', label: 'Australia' },
    ];
    $scope.loading = false;
    $scope.updating = false;

    // Methods
    $scope.updateCompany = updateCompany;

    // Main
    fetchCompany();

    // Functions
    function fetchCompany() {
        $scope.loading = true;

        return $settingsFetcher
            .key('company')
            .then(
                $util.nextTick(result => {
                    $scope.setting = result.data.find(s => s.team_id === null);
                    $scope.company = angular.copy($scope.setting.value) || {};
                }),
            )
            .catch(
                $util.nextTick(error => {
                    $errorHandler.handle(error);
                }),
            )
            .finally(
                $util.nextTick(() => {
                    $scope.loading = false;
                }),
            );
    }

    function updateCompany($event) {
        console.log($event);

        $scope.updating = true;

        const toast = $app.progressToast('Saving');

        const hasCompany = $installation.hasCompany;

        $settingsFetcher
            .update('company', {
                value: $scope.company,
            })
            .then(
                $util.nextTick(result => {
                    $scope.setting = result.data;
                    $scope.company = result.data.value;

                    $installation.hasCompany = true;

                    if (!hasCompany) {
                        // Go to the next step
                        $state.go($installation.nextStep);
                    }

                    $app.successToast('Saved');
                }),
                $util.nextTick(error => {
                    $errorHandler.handle(error);
                }),
            )
            .finally(
                $util.nextTick(() => {
                    toast.hide();

                    $scope.updating = false;
                }),
            );
    }
}

export { template, CompanyController as controller };
